'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import utils from 'services/utils';

const propTypes = {
    icon: PropTypes.string,
    loading: PropTypes.bool,
    name: PropTypes.string,
};

import 'styles/LoadingHeader.scss';

class LoadingHeader extends React.Component {

    render() {

        var className = classNames(
            'lh', 
            {'white': this.props.hasColoredBackground, 
                'has-icon': this.props.icon}
        );

        /*var gradientColor = this.props.color || '#ffffff';
        var rgbGradientColor = utils.hexToRgb(gradientColor);
        var styles = {background: "linear-gradient(to bottom,  rgba(" + rgbGradientColor.r + "," + rgbGradientColor.g +"," + rgbGradientColor.b + ",1) 0%,rgba(" + rgbGradientColor.r + "," + rgbGradientColor.g +"," + rgbGradientColor.b + ",1) 23%,rgba(" + rgbGradientColor.r + "," + rgbGradientColor.g +"," + rgbGradientColor.b + ",0) 36%,rgba(" + rgbGradientColor.r + "," + rgbGradientColor.g +"," + rgbGradientColor.b + ",0) 64%,rgba(" + rgbGradientColor.r + "," + rgbGradientColor.g +"," + rgbGradientColor.b + ",1) 77%,rgba(" + rgbGradientColor.r + "," + rgbGradientColor.g +"," + rgbGradientColor.b + ",1) 100%)"};
       */
        return (
            <div className={className}>
                <i className={this.props.icon} />
                <div className={this.props.loading ? "heading loading" : "heading"}>
                    <div className="normal-header">
                        {this.props.children} 
                    </div>
                    <div className="loading-header">
                        {"Checking " + this.props.children + "..."}
                    </div>
                </div>
            </div>
        );
    }
}

LoadingHeader.propTypes = propTypes;

export default LoadingHeader;
